import React, {useEffect, useState, useCallback} from "react";
import {useNavigate, useParams, useLocation} from "react-router-dom";
import moment from "moment";
import {executeGet, executePost} from "../../Api";
import { eventUrl, saveLogRocketSession } from "../../utils";
import ReconcileAllDates from "./ReconcileAllDates";
import ReconcileDate from "./ReconcileDate";
import "./payersTable.css";

const Reconcile = (props) => {
    const {subdomain, themeColor1} = props;
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    const [selectedDate, setSelectedDate] = useState(null);
    const [portalTransactions, setPortalTransactions] = useState([]);
    const [batchedTransactions, setBatchedTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [batchedLoading, setBatchedLoading] = useState(false);
    const [timezone, setTimezone] = useState('UTC');

    const handleSelectDate = useCallback((date) => {
        console.log('handleSelectDate called with date:', date.format('YYYY-MM-DD'));

        // Just navigate to the URL - let useEffect handle the data fetching
        const targetUrl = `${eventUrl(subdomain)}adminDashboard/reconcile/${date.format('YYYY-MM-DD')}`;
        navigate(targetUrl, { replace: true });
    }, [subdomain, navigate]);

    const fetchReconciliationData = useCallback(async (date) => {
        console.log('fetchReconciliationData called for date:', date.format('YYYY-MM-DD'));

        // Set loading states and selected date
        setSelectedDate(date);
        setLoading(true);
        setBatchedLoading(true);

        try {
            // Fetch portal transactions
            const portalUrl = `transaction/reconcile/portal?subdomain=${subdomain}&date=${date.format('YYYY-MM-DD')}`;
            console.log('Fetching portal transactions from:', portalUrl);
            const portalResult = await executeGet(portalUrl, {});
            const portalData = portalResult.data?.data || [];
            const tz = portalResult.data?.timezone || 'UTC';
            console.log('Portal data received:', portalData.length, 'transactions');

            setTimezone(tz);
            setPortalTransactions(Array.isArray(portalData) ? portalData : []);
            setLoading(false);

            // Fetch batched transactions from NMI
            const batchedUrl = `transaction/reconcile/batched?subdomain=${subdomain}&date=${date.format('YYYY-MM-DD')}`;
            console.log('Fetching batched transactions from:', batchedUrl);
            const batchedResult = await executeGet(batchedUrl, {});
            const batchedData = batchedResult.data?.data || [];
            console.log('Batched data received:', batchedData.length, 'transactions');

            // Generate detailed reconciliation log
            try {
                await executePost(`transaction/reconcile/log?subdomain=${subdomain}&date=${date.format('YYYY-MM-DD')}`, {});
                console.log('Detailed reconciliation log generated successfully');
            } catch (logError) {
                console.error('Error generating reconciliation log:', logError);
            }

            setBatchedTransactions(Array.isArray(batchedData) ? batchedData : []);
            setBatchedLoading(false);
        } catch (error) {
            console.error("Error fetching reconciliation data:", error);
            setPortalTransactions([]);
            setBatchedTransactions([]);
            setLoading(false);
            setBatchedLoading(false);
            saveLogRocketSession({ eventType: "reconcile_error", metadata: { error: String(error) } });
        }
    }, []);

    const handleBack = useCallback(() => {
        setSelectedDate(null);
        setPortalTransactions([]);
        setBatchedTransactions([]);
        navigate(`${eventUrl(subdomain)}adminDashboard/reconcile`, { replace: true });
    }, [subdomain, navigate]);

    // Check URL for date parameter on mount and URL changes
    useEffect(() => {
        const pathname = location.pathname;
        console.log('useEffect triggered - pathname:', pathname);

        const reconcileMatch = pathname.match(/\/adminDashboard\/reconcile\/(\d{4}-\d{2}-\d{2})/);
        const dateParam = reconcileMatch ? reconcileMatch[1] : null;

        console.log('URL check - dateParam:', dateParam);
        console.log('Current selectedDate:', selectedDate ? selectedDate.format('YYYY-MM-DD') : null);

        // Only load if we have a date and it's different from currently selected
        if (dateParam && (!selectedDate || selectedDate.format('YYYY-MM-DD') !== dateParam)) {
            const parsedDate = moment(dateParam);
            if (parsedDate.isValid()) {
                console.log('Loading reconciliation for date from URL:', parsedDate.format('YYYY-MM-DD'));
                fetchReconciliationData(parsedDate);
            }
        }
    // }, [location.pathname, selectedDate, fetchReconciliationData]);
    }, [location.pathname, selectedDate, fetchReconciliationData]);


    console.dir('selectedDate #slkdnkfln')
    console.dir(selectedDate)
    console.dir('a lot of stuff ....... ')
    console.dir({
        selectedDate,
        portalTransactions,
        batchedTransactions,
        loading,
        batchedLoading,
    }, {depth:null});

    return (
        <div className="intake-content-admin">
            <div className="jumbotron p-4 p-lg-5">
                <h2 className="mb-4">Reconcile Transactions</h2>

                {!selectedDate && (
                    <ReconcileAllDates
                        themeColor1={themeColor1}
                        onSelectDate={handleSelectDate}
                    />
                )}

                {selectedDate && (
                    <ReconcileDate
                        selectedDate={selectedDate}
                        portalTransactions={portalTransactions}
                        batchedTransactions={batchedTransactions}
                        loading={loading}
                        batchedLoading={batchedLoading}
                        timezone={timezone}
                        themeColor1={themeColor1}
                        onBack={handleBack}
                    />
                )}
            </div>
        </div>
    );
};

export default Reconcile;
